import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    CertificateOfIncorporationFileKey = 'certificateOfIncorporationFileKey',
    MemorandumAndArticlesFileKey = 'memorandumAndArticlesFileKey',
    CompanyAccountBankStatementFileKey = 'companyAccountBankStatementFileKey',
    CompanyFinancialStatementFileKey = 'companyFinancialStatementFileKey',
    BankReferenceFileKey = 'bankReferenceFileKey',
    CopyOfLicencesFileKey = 'copyOfLicencesFileKey',
    ProofOfDomainOwnershipFileKey = 'proofOfDomainOwnershipFileKey',
    PassportsOfShareholdersFileKey = 'passportsOfShareholdersFileKey',
    UtilityBillOfShareholdersFileKey = 'utilityBillOfShareholdersFileKey',
    OfficialCompanyDocWithAuthorityFileKey = 'officialCompanyDocWithAuthorityFileKey',
    StructureChartFileKey = 'structureChartFileKey'
};

export type OnboardingUploadDocuments = {
    readonly [FormField.CertificateOfIncorporationFileKey]: string | null;
    readonly [FormField.MemorandumAndArticlesFileKey]: string | null;
    readonly [FormField.CompanyAccountBankStatementFileKey]: string | null;
    readonly [FormField.CompanyFinancialStatementFileKey]: string | null;
    readonly [FormField.BankReferenceFileKey]: string | null;
    readonly [FormField.CopyOfLicencesFileKey]: string | null;
    readonly [FormField.ProofOfDomainOwnershipFileKey]: string | null;
    readonly [FormField.PassportsOfShareholdersFileKey]: string | null;
    readonly [FormField.UtilityBillOfShareholdersFileKey]: string | null;
    readonly [FormField.OfficialCompanyDocWithAuthorityFileKey]: string | null;
    readonly [FormField.StructureChartFileKey]: string | null;
};

export type OnboardingUploadDocumentsBootstrapData = {};

export type OnboardingUploadDocumentsForm = Omit<
    BootstrapableForm<OnboardingUploadDocuments, OnboardingUploadDocumentsBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingUploadDocuments;
};

export type OnboardingUploadDocumentsProps =
    & OnboardingFormProps
    & OnboardingUploadDocumentsForm
    & ReturnType<typeof useForm<OnboardingUploadDocuments>>;
